import React from 'react';
import { Col } from 'reactstrap';
import Select from 'react-select';
import { useEffect } from 'react';

const DropDownDynamicOptoins = (props) => {
    const onSelectChanged = (e) => {
        props.changed(e);
    };
    return (
        <React.Fragment>
            <div className="mb-0 form-floating w-100">
                {props.type === 126 ? (
                    <Select
                        className="w-100 ht-fitcontent"
                        value={
                            !!props?.value
                                ? props?.dynamicOptions
                                      ?.map((e) => {
                                          return {
                                              label: e,
                                              value: `${e}_${props?.answerInternalIdentifier}`,
                                              valueID: props?.answerInternalIdentifier
                                          };
                                      })
                                      ?.find((e) => e.label === props?.value)
                                : ''
                        }
                        onChange={onSelectChanged}
                        options={props?.dynamicOptions?.map((e) => {
                            return {
                                label: e,
                                value: `${e}_${props?.answerInternalIdentifier}`,
                                valueID: props?.answerInternalIdentifier
                            };
                        })}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        id={props.questionId}
                        isDisabled={props.disable}
                        onBlur={props.handleOnBlur}
                        // getOptionLabel={(e) => e.valueDesc}
                        // getOptionValue={(e) => e.value}
                    />
                ) : (
                    <Select
                        className="w-100 ht-fitcontent"
                        value={
                            typeof props.value === 'string'
                                ? props.categoryValueTypeDto?.options?.find((i) => i.valueDesc === props.value)
                                : props.value
                        }
                        onChange={onSelectChanged}
                        options={props.categoryValueTypeDto?.options}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        id={props.questionId}
                        isDisabled={props.disable}
                        onBlur={props.handleOnBlur}
                        getOptionLabel={(e) => e.valueDesc}
                        getOptionValue={(e) => e.valueID}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default DropDownDynamicOptoins;
